import React, { useState, useEffect, useContext, Fragment, useRef, useCallback } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { AuthContext } from '../contexts/auth';
import { postNotificationDWH } from '../services/api_calendar';
import Footer from './footer';
import CalendarWeekSelect from './calendar_week_select';
import ComboboxAutocomplete from './combobox_autocomplete';
import { ChevronDownIcon, ChevronUpIcon, BriefcaseIcon, PlusCircleIcon, ChevronRightIcon, ChevronLeftIcon, TrashIcon, PencilSquareIcon, InformationCircleIcon, NoSymbolIcon, PlusIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Link } from 'wouter';
import { getWorkingHoursCompound, getWeeklyWorkingHourCompound } from '../services/api_working_hours';
import { getCalendarWorkingHour, createEmployeeWorkingHour, deleteEmployeeDailyWorkingHour, updateEmployeeDailyWorkingHour, getCalendarTotalHours, updateEmployeeWorkingHourStatus, updateEmployeeDWHOuPair } from '../services/api_calendar';
import { getEmployeesWithActiveContract } from "../services/api_calendar";
import { getCompanySettings } from '../services/api_settings';
import Swal from 'sweetalert2';
import Toggle from './toggle';
import { AddDailyWorkingHour } from './add_daily_working_hour_calendar';
import { convertWorkingHourToShifts } from '../utils/timeslots';
import { listOrganizationalUnits } from '../services/api_org_unit';
import { getMonthBlocked } from '../services/api_months_blocked';
import Fetching from './fetching';
import moment from 'moment';
import ComboboxMultiSelectAPI from './combobox_multiselect_autocomplete_api';
import ListBoxPageSize from './listbox_pase_size';
import PairOrgUnit from './pair_org_unit';
import InactiveEmployeesTable from './inactive_employees_table';
import ShiftCard from './shift_card';
import OuSelectionPairDWH from './modal_select_OU_to_pair_DWH';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import PopoverComponentCustom from './popover_component';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import TabellaTurnoGiornaliero from './tabella_visualizza_turno giornaliero';
import { formatHoursAndMinutes } from '../utils/workTimeCount';

// import { EditDailyWorkingHour } from './edit_daily_working_hour_calendar';


function isWeekWorkingHours(obj) {
    if (!obj)
        return false;
    return 'slots_by_weekday' in obj;
}

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
'& .MuiTooltip-tooltip': {
    backgroundColor: '#a3a3a3',
    color: '#FFFFFF',
    fontSize: '0.8rem',
},
});

const TableAssignWh = () => {
    const { token, profile } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingEmployee, setLoadingEmployee] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorSetting, setErrorSetting] = useState(false);
    const [loadingTotalHours, setLoadingTotalHours] = useState(false);
    const [isTotalHoursError, setIsTotalHoursError] = useState(false);
    const [selectedActiveContractEmployees, setSelectedActiveContractEmployees] = useState([]);
    const [currentWeek, setCurrentWeek] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const [firstDayOfMonth, setFirstDayOfMonth] = useState(new Date());
    const currentMonthName = firstDayOfMonth.toLocaleString('it-IT', { month: 'long' }).toLowerCase();
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [workingHours, setWorkingHours] = useState([]);
    const [employeeWorkingHours, setEmployeeWorkingHours] = useState([]);
    const [selectedDay, setSelectedDay] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedWorkingHourId, setSelectedWorkingHourId] = useState(null);
    const [selectedWeeklyWorkingHourId, setSelectedWeeklyWorkingHourId] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState();
    const [employeesWithActiveContract, setEmployeesWithActiveContract] = useState([]);
    const [showButton, setShowButton] = useState(true);
    const [showInactiveEmployee, setShowInactiveEmployee] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [employeesCalendarData, setEmployeesCalendarData] = useState([]);
    const [weeklyWorkingHours, setWeeklyWorkingHours] = useState([]);
    const daysOfWeek = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];
    const weekendDays = [6]; 
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [units, setUnits] = useState([]); 
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [holidays, setHolidays] = useState([]);
    const [notificationsToSend, setNotificationsToSend] = useState([]);
    const [selectedNotifications, setSelectedNotifications] = useState([]);
    const [selectedEmployeeName, setSelectedEmployeeName] = useState({});
    const [totalResultActiveContract, setTotalResultActiveContract] = useState(0);
    const [pageActiveContract, setPageActiveContract] = useState(1);
    const [pageSizeActiveContract, setPageSizeActiveContract] = useState(25);
    const [totalPlannedHours, setTotalPlannedHours] = useState(0);
    const [totalAssignedHours, setTotalAssignedHours] = useState(0);
    const [temporarySelectedUnit, setTemporarySelectedUnit] = useState(selectedUnit || null);
    const [selectedOuToPair, setSelectedOuToPair] = useState(null);
    const [unconfirmedShiftsIds, setUnconfirmedShiftsIds] = useState([]);
    const [isModalOuPairingOpen, setIsModalOuPairingOpen] = useState(false);
    const [selectedDWH, setSelectedDWH] = useState({});
    const [blockedMonths, setBlockedMonths] = useState([]);
    const [oraInizio, setOraInizio] = useState('');
    const [oraFine, setOraFine] = useState('');
    // const [isNightShiftActive, setIsNightShiftActive] = useState(false);

    const controller = useRef(null);

    const selectedWorkingHour = Array.isArray(workingHours) 
    ? workingHours.find(wh => wh.id === selectedWorkingHourId) 
    : null;

    const wwhEmployeeData = Array.isArray(weeklyWorkingHours) 
    ? weeklyWorkingHours.find(wwh => wwh.id === selectedWeeklyWorkingHourId) 
    : null;

    
    const wwhEmployeeDataDisplay = selectedWorkingHour || wwhEmployeeData;  
    const hidePaginationActive = totalResultActiveContract <= pageSizeActiveContract;
    const isProfileComplete = profile.has_complete_profile;


    useEffect(() => {
        const fetchUnits = async () => {
            setIsLoading(true);
            setIsError(false);
    
            try {
                const response = await listOrganizationalUnits(token, true, null, 'shifts');

                setUnits(response.data || [] );
            } catch (error) {
                console.error('Error fetching units:', error);
                {(error.response.status !== 402) &&
                    setIsError(true);
                    setIsLoading(false);
                }
            } finally {
                setIsLoading(false);
            }
        };
    
        fetchUnits();
    }, [token]);

    useEffect(() => {
        if (selectedUnit) {
            setTemporarySelectedUnit(selectedUnit);
        } else {
            setTemporarySelectedUnit(null);
        }
    }, [selectedUnit]);
    

    useEffect(() => {
        if(controller.current) {
            controller.current.abort();
            setLoadingEmployee(false);
        }
        
        controller.current = new AbortController();

        const signal = controller.current.signal;
    
        const getData = async () => {
            if (currentWeek.length === 0) return;

            setIsError(false);
            setLoadingEmployee(true);
    
            try {
                const startDate = formatDateWeekSelected(currentWeek[0]);
                const endDate = formatDateWeekSelected(currentWeek[currentWeek.length - 1]);

                const calendarResponse = await getCalendarWorkingHour(
                    token, { startDate, endDate },
                    selectedUnit?.id, selectedActiveContractEmployees.map(e => e.id),
                    pageActiveContract, pageSizeActiveContract,
                    signal,
                    'shifts'
                );
                
                let arrayCalendarResponse = [];
                if (Array.isArray(calendarResponse.results)) {
                    arrayCalendarResponse = calendarResponse.results;
                }


                const activeEmployees = (Array.isArray(arrayCalendarResponse) ? arrayCalendarResponse : []).map(employee => ({
                    first_name: employee.first_name,
                    last_name: employee.last_name,
                    cf: employee.cf,
                    id: employee.id,
                    active_contract: employee.active_contract,
                }));
                setTotalResultActiveContract(calendarResponse.count);
    
                setEmployeesCalendarData(calendarResponse.results);

                const holidaysData = [];
                arrayCalendarResponse.forEach(employee => {
                    employee.days.forEach(day => {
                        if (day.holidays && day.holidays.length > 0) {
                            day.holidays.forEach(holiday => {
                                holidaysData.push({ date: day.date, name: holiday.name });
                            });
                        }
                    });
                });
                setHolidays(holidaysData);
    
                setEmployeesWithActiveContract(activeEmployees);
                setSelectedEmployees(activeEmployees);
    
                const employeeWorkingHoursData = arrayCalendarResponse.flatMap(entry =>
                    entry.days.map(day => ({
                        employeeId: entry.id,
                        employeeCf: entry.cf,
                        employeeLastName: entry?.last_name,
                        employeeFirstName: entry?.first_name,
                        date: day.date,
                        typology: entry.typology,
                        shifts: Array.isArray(day.shifts) ? day.shifts.map(shift => ({
                            ref_name: shift.ref_name,
                            ref_ou: shift.ref_ou,
                            dailyWorkingHourId: shift.daily_working_hour,
                            status: shift.status,
                            typology: shift.typology,
                            time_slots: Array.isArray(shift.time_slots) 
                                ? shift.time_slots.map(slot => ({
                                    ...slot,
                                    date: day.date,
                                }))
                                : [],
                        })) : [],
                        has_active_contract: day.has_active_contract,
                        week_hours: day.week_hours,
                        shift_type: day.shift_type,
                    }))
                );               
                
                // setSelectedEmployees(activeEmployees);
                setEmployeeWorkingHours(employeeWorkingHoursData);

                const unconfirmedShifts = employeeWorkingHoursData.flatMap(emp =>
                    emp.shifts
                        .filter(shift => shift.status === false)
                        .map(shift => ({
                            employeeId: emp.employeeId, 
                            dailyWorkingHourId: shift.dailyWorkingHourId,
                            employee: emp,
                            shiftDays: emp.date,
                        }))
                );
                
                setUnconfirmedShiftsIds(unconfirmedShifts);

                const blockedMonthsResponse = await getMonthBlocked(token, { startDate, endDate }, 'shifts');
                setBlockedMonths(blockedMonthsResponse);

                setLoadingEmployee(false);
            } catch (error) {
                if (error?.name != 'CanceledError') {
                    console.error(error);
                    setIsError(true);
                    setLoadingEmployee(false);
                }
            }

        };
    
        getData();

        // return () => {
        //     controller.current.abort()
        // }
    
    }, [token, currentWeek, selectedUnit, pageActiveContract, pageSizeActiveContract, selectedActiveContractEmployees]);

    const updateTotalHours = useCallback(async () => {
        if (!currentWeek || currentWeek.length === 0) return;

        try {
            const startDate = formatDateWeekSelected(currentWeek[0]);
            const endDate = formatDateWeekSelected(currentWeek[currentWeek.length - 1]);

            setLoadingTotalHours(true);
            setIsTotalHoursError(false);

            const totalHoursResponse = await getCalendarTotalHours(
                token,
                { startDate, endDate },
                selectedUnit?.id,
                selectedActiveContractEmployees.map(e => e.id),
                'shifts'
            );

            let arraytotalHours = [];
            if (Array.isArray(totalHoursResponse.results)) {
                arraytotalHours = totalHoursResponse.results;
            }

            setTotalPlannedHours(totalHoursResponse.week_hours_expected);
            setTotalAssignedHours(totalHoursResponse.week_hours_actual);
            setLoadingTotalHours(false);
        } catch (error) {
            if (error?.name != 'CanceledError') {
                console.error("Errore nell'aggiornamento delle ore totali:", error);
                {(error.response.status !== 402) &&
                    setIsTotalHoursError(true);
                    setLoadingTotalHours(false);
                }
            }
        }
    }, [token, currentWeek, selectedUnit, selectedActiveContractEmployees]);

    useEffect(() => {
        updateTotalHours();
    }, [updateTotalHours]);

    // useEffect(() => {
    //     const fetchSettings = async () => {
    //         try {
    //         const response = await getCompanySettings(token, 'attendance');
    //         const settings = response.data;
            
    //         setIsNightShiftActive(settings?.night_shift_active || false);
    //         setOraInizio(moment(settings?.night_shift_start, "HH:mm:ss").format("HH:mm"));
    //         setOraFine(moment(settings?.night_shift_end, "HH:mm:ss").format("HH:mm"));

    //         } catch (err) {
    //         setErrorSetting("Errore durante il caricamento delle impostazioni.");
    //         console.error(err);
    //     }
    // };

    // fetchSettings();
    // }, [token]);
    
    const isDayBlocked = (date) => {
        const day = new Date(date);
        const year = day.getFullYear();
        const month = day.getMonth() + 1;
        
        return blockedMonths.some(blocked => blocked.year === year && blocked.month === month);
    };
    
    const handleNextPageActive = () => {
        if (pageActiveContract * pageSizeActiveContract < totalResultActiveContract) {
          setPageActiveContract(prevPage => prevPage + 1);
        }
    };
    
    const handlePreviousPageActive = () => {
        if (pageActiveContract > 1) {
            setPageActiveContract(prevPage => prevPage - 1);
        }
    };

    const handlePageSizeActiveChange = (newPageSize) => {
        setPageSizeActiveContract(newPageSize);
        setPageActiveContract(1);
    };
    
    const isWeekend = (date) => {
        const dayOfWeek = new Date(date).getDay();
        return dayOfWeek === 0; // 0 = Domenica
    };

    const formatDateWeekSelected = (date) => {

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    useEffect(() => {
        const fetchWorkingHours = async () => {
            try {
                const workingHoursData = await getWorkingHoursCompound(token, selectedUnit?.id, 'shifts');
                setWorkingHours(workingHoursData || []);
            } catch (error) {
                console.error('Errore durante il recupero del turno', error);
            }
        };
    
        fetchWorkingHours();
    }, [token, selectedUnit]);

    useEffect(() => {
        if (workingHours && workingHours.length > 0) {
            setWorkingHours(workingHours);
        }
    }, [workingHours]);

    useEffect(() => {
        const fetchWeekWorkingHours = async () => {
            try {
                const weeklyWorkingHours = await getWeeklyWorkingHourCompound(token, selectedUnit?.id, null, 'shifts');
                setWeeklyWorkingHours(weeklyWorkingHours || []);
                
            } catch (error) {
                console.error('Errore durante il recupero del turno', error);
            }
        };

        fetchWeekWorkingHours();
    }, [token, selectedUnit]);
    
    const handleSelectionActiveContractChange = (newSelectedEmployees) => {
        setSelectedActiveContractEmployees(newSelectedEmployees);
    };

    const handleDeselectEmployee = (employeeId) => {
        setSelectedActiveContractEmployees((prevSelected) =>
            prevSelected.filter((emp) => emp.id !== employeeId)
        );
    };

    const handleResetSelection = () => {
        setSelectedActiveContractEmployees([]);
    };

    useEffect(() => {
        const today = new Date();
        setCurrentWeek(getCompleteWeek(today));
    }, []);

    const getCompleteWeek = (date) => {
        const currentDayOfWeek = date.getDay();
        const mondayDiff = currentDayOfWeek === 0 ? -6 : 1 - currentDayOfWeek;
        const monday = new Date(date);
        monday.setDate(date.getDate() + mondayDiff);
        const weekDays = [monday];
        for (let i = 1; i < 7; i++) {
            const day = new Date(monday);
            day.setDate(monday.getDate() + i);
            weekDays.push(day);
        }
        return weekDays;
    };

    const getWeekRange = (monday, sunday) => {
        const startDay = monday.getDate();
        const endDay = sunday.getDate();
    
        const startMonth = monday.toLocaleDateString('it-IT', { month: 'long' });
        const endMonth = sunday.toLocaleDateString('it-IT', { month: 'long' });
    
        if (startMonth !== endMonth) {
            return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
        }
    
        return `${startDay} - ${endDay} ${startMonth}`;
    };

    const formatDay = (date) => {
        if (!date) return "";
        const options = { weekday: 'short', day: 'numeric' };
        return date.toLocaleDateString('it-IT', options);
    };

    const handleWeekSelect = (weekDays) => {
        setCurrentWeek(weekDays);
        if (weekDays.length > 0) {
            const firstDayOfWeek = weekDays[0];
            setSelectedMonth(new Date(firstDayOfWeek.getFullYear(), firstDayOfWeek.getMonth(), 1));
        }
    };

    const handleNavigateWeek = (direction) => {
        const newMonday = new Date(currentWeek[0]);
        newMonday.setDate(newMonday.getDate() + 7 * direction);
        setCurrentWeek(getCompleteWeek(newMonday));
        setSelectedMonth(new Date(newMonday.getFullYear(), newMonday.getMonth(), 1));
    };
    
    const handleSelectClick = () => {
        setCalendarVisible(!calendarVisible);
    };

    const shiftAssigned = currentWeek.map((day, index) => {
        const dateSelected = formatDay(day);
        const selectedEmployeeShift = selectedWorkingHour?.time_slots.find((item) => item.day === dateSelected);
        
        return {
            day: dateSelected,
            shiftHour: selectedEmployeeShift ? selectedEmployeeShift.id : '',
        };
    });
    
    const formatDate = (date) => {
        return moment(date).format('YYYY-MM-DD')
        // return date.toISOString().split('T')[0];
    };

    const handlePlusCircleClick = (employeeId, day, cf, lastName, firstName, selectedUnit) => {
        if (profile.customer_type !== 'employee' || 
            profile.employee?.permissions.includes('hr.manage_shifts_all') || 
            profile.employee?.permissions.includes('hr.manage_shifts_ou')) {
            
            handleSelectedDay(employeeId, day, cf, lastName, firstName, selectedUnit.id);
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Non hai i permessi per eseguire questa azione',
                confirmButtonText: 'OK'
            });
        }
    };
    
    const handleSelectedDay = (employeeId, day, cf, employeeLN, employeeFN) => {
        setSelectedEmployee(employeeId);
        setSelectedDay(day);

        const fullName = (employeeLN && employeeFN) 
            ? `${employeeLN} ${employeeFN}`.trim() 
            : cf;

        setSelectedEmployeeName(fullName);
        
        // const currentEmployee = employeesWithActiveContract.find(employee => employee.id === employeeId);
        const employeeCalendarData = employeesCalendarData.find(data => data.id === employeeId);
        const typology = employeeCalendarData ? employeeCalendarData.typology : null;

        const dayBlocked = isDayBlocked(day); 

        if (dayBlocked) {
            Swal.fire({
                icon: 'error',
                title: 'Il giorno è bloccato',
                text: 'Non è possibile modificare questo giorno.',
                showConfirmButton: true,
                confirmButtonText: 'OK',
            });
            return;
        }
    
        if (typology === 'fisso') {
            Swal.fire({
                icon: 'info',
                title: 'Turno Fisso',
                text: 'Il dipendente selezionato ha il contratto con turno fisso e può essere assegnato nella sezione anagrafica',
                showCancelButton: true,
                confirmButtonText: 'Vai all\'anagrafica',
                cancelButtonText: 'Annulla',
                cancelButtonColor: '#d1d5db',
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = `/dipendenti/${cf}/edit?tab=4`;
                }
            });
        } else {
            setModalOpen(true);
        }
    };

    const handleTemporarySelectUnit = (selectedUnit) => {
        setTemporarySelectedUnit(() => selectedUnit);
    };
    

    useEffect(() => {
    }, [temporarySelectedUnit, selectedUnit]);  
    
    
    const handleSaveWorkingHour = async (shiftPreviews) => {
        let workingHourData;
        const formattedDate = moment(selectedDay).format('DD/MM/YYYY');       

        if (selectedOption === "CREA FASCIA ORARIA") {
            // Creazione di una nuova fascia oraria
            workingHourData = {
                date: selectedDay,
                working_hour: null,
                time_slots: shiftPreviews.map(preview => ({
                    start_at: preview.workStartTime,
                    end_at: preview.workEndTime,
                    breaks: preview.breaks.map(b => ({
                        start_at: b.start_at,
                        end_at: b.end_at
                    }))
                })),
                ou: temporarySelectedUnit?.id,
                name: temporarySelectedUnit?.name,
                typology: 'custom',
            };
        } else {
            // Selezione di una fascia oraria esistente
            const selectedWorkingHour = workingHours.find(wh => wh.id === selectedWorkingHourId);
    
            if (!selectedWorkingHour) {
                console.error('Fascia oraria non trovata');
                return;
            }
    
            workingHourData = {
                date: selectedDay,
                working_hour: selectedWorkingHour.id,
                time_slots: selectedWorkingHour.time_slots.map(slot => ({
                    start_at: slot.start_at,
                    end_at: slot.end_at,
                    breaks: slot.breaks.map(b => ({
                        start_at: b.start_at,
                        end_at: b.end_at
                    }))
                })),
                ou: selectedUnit?.id,
                name: selectedUnit?.name,
            };
        }
    
        try {
            if (selectedEmployee !== undefined) {

                Swal.fire({
                    title: 'Assegnazione turno...',
                    icon: 'info',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                
                const responseDWH = await createEmployeeWorkingHour(token, selectedEmployee, workingHourData);
    
                const time_slots = responseDWH.working_hour ? convertWorkingHourToShifts(responseDWH.working_hour, workingHours) : responseDWH.time_slots;
                // crea nuovo turno con typology CUSTOM se era stata selezionata l'opzione crea fascia oraria
                const isCustom = selectedOption === "CREA FASCIA ORARIA";

                await updateTotalHours();
    
                const indexToUpdate = employeeWorkingHours.findIndex(entry => entry.employeeId === selectedEmployee && entry.date === responseDWH.date);
                
                const newShift = {
                    ref_name: responseDWH.ref_name,
                    ref_ou: responseDWH.ou,
                    dailyWorkingHourId: responseDWH.id,
                    typology: isCustom ? 'custom' : responseDWH.typology,
                    time_slots: time_slots,
                }

                // Crea un nuovo array con il dato aggiornato
                const updatedEmployeeWorkingHours = [...employeeWorkingHours];
                if (indexToUpdate !== -1) {
                    updatedEmployeeWorkingHours[indexToUpdate] = {
                        ...updatedEmployeeWorkingHours[indexToUpdate],
                        dailyWorkingHourId: responseDWH.id,
                        typology: 'turno',
                        time_slots: time_slots,
                        ref_name: responseDWH.ref_name,
                        ref_ou: responseDWH.ref_ou,
                        shifts: [...updatedEmployeeWorkingHours[indexToUpdate]?.shifts, newShift],
                    };
                } else {
                    // Se il giorno selezionato non è già presente, aggiungilo all'array
                    updatedEmployeeWorkingHours.push({
                        employeeId: selectedEmployee,
                        date: responseDWH.date,
                        dailyWorkingHourId: responseDWH.id,
                        typology: 'turno',
                        time_slots: time_slots,
                        ref_ou: workingHourData.ou,
                        shifts: [newShift],
                    });
                }
    
                setEmployeeWorkingHours(updatedEmployeeWorkingHours);

                // aggiungi l'id del nuovo turno e dell'eployee agli id dei turni da confermare
                setUnconfirmedShiftsIds(prevUnconfirmedShiftsIds => [
                    ...prevUnconfirmedShiftsIds, 
                    { employeeId: selectedEmployee, dailyWorkingHourId: responseDWH.id }
                ]);
                
                setNotificationsToSend(prevNotifications => [
                    ...prevNotifications,
                    { employeeId: selectedEmployee, title: `Notifica turno - ${selectedEmployeeName}`, message: `Hai un nuovo turno assegnato il ${formattedDate}` }
                ]);
                
                setSelectedOption('');
                setSelectedWorkingHourId(null);
                setSelectedWeeklyWorkingHourId(null);
                setModalOpen(false);
                if (selectedUnit)
                    setTemporarySelectedUnit(selectedUnit);
                else
                    setTemporarySelectedUnit('');
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Turno assegnato con successo!",
                    showConfirmButton: false,
                    timer: 1000,
                });
            } else {
                throw new Error('Nessun dipendente selezionato');
            }
        } catch (error) {
            console.error('Errore durante l\'assegnazione del turno:', error);
            let errorMessage = 'Si è verificato un errore durante l\'assegnazione del turno. Per favore riprova.';
        
            if (error.response && error.response.data) {
                const errorData = error.response.data;
                const errorMessages = [];
        
                Object.keys(errorData).forEach((key) => {
                    const messageArray = errorData[key];
                    if (Array.isArray(messageArray)) {
                      errorMessages.push(...messageArray);
                    } else if (typeof messageArray === 'string') {
                      errorMessages.push(messageArray);
                    }
                });
        
                if (errorMessages.length > 0) {
                    errorMessage = errorMessages.join(' ');
                }
            }
        
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: errorMessage,
                confirmButtonText: 'OK',
            });
        }
    };
    
    const handleSaveWeekWorkingHour = async () => {
        try {
            if (!selectedEmployee) {
                throw new Error('Nessun dipendente selezionato');
            }
    
            if (selectedOption !== "CREA FASCIA ORARIA" && !selectedWeeklyWorkingHourId) {
                throw new Error('Nessuna fascia oraria selezionata');
            }
    
            const selectedWeekWorkingHour = weeklyWorkingHours.find(wwh => wwh.id === selectedWeeklyWorkingHourId);
    
            if (!selectedWeekWorkingHour || !selectedWeekWorkingHour.slots_by_weekday) {
                throw new Error('Turno settimanale non trovato o dati incompleti');
            }
    
            // Usa moment per ottenere la data formattata
            const formattedDateShift = moment(selectedDay).format('DD/MM/YYYY');
    
            // Usa moment per calcolare l'inizio della settimana per la data selezionata
            const startOfWeek = moment(selectedDay).startOf('isoWeek'); // Inizio settimana (lunedì)
    
            // Converti startOfWeek in un array di date della settimana (da lunedì a domenica)
            const weekDates = [];
            for (let i = 0; i < 7; i++) {
                const currentDay = startOfWeek.clone().add(i, 'days');
                weekDates.push(currentDay.format('YYYY-MM-DD')); // Aggiungi la data formattata
            }
    
            let updatedEmployeeWorkingHours = [...employeeWorkingHours];
            const conflictingDates = [];
    
            // Verifica se ci sono turni esistenti per qualsiasi giorno della settimana
            for (const formattedDateShift of weekDates) {
                const existingEntry = updatedEmployeeWorkingHours.find(entry => 
                    entry?.employeeId === selectedEmployee && entry?.date === formattedDateShift
                );
    
                if (existingEntry) {
                    // Controlla se ci sono turni (shifts) per il giorno e se contengono time_slots
                    const shiftsWithTimeSlots = existingEntry.shifts.filter(shift =>
                        Array.isArray(shift.time_slots) && shift.time_slots.length > 0
                    );
                    if (shiftsWithTimeSlots.length > 0) {
                        // Aggiungi il giorno ai conflitti
                        conflictingDates.push(formattedDateShift);
    
                    }
                }
            }

            // Verifica se ci sono turni da sovrascrivere
            let shouldOverride = false;
            if (conflictingDates.length > 0) {
                const result = await Swal.fire({
                    title: 'Turni esistenti trovati',
                    text: `Sono presenti dei turni assegnati nella settimana. Vuoi sovrascriverli con il turno settimanale selezionato?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sì, sovrascrivi',
                    cancelButtonText: 'No, annulla'
                });
    
                if (result.isConfirmed) {
                    shouldOverride = true;
                    Swal.fire({
                        title: 'Assegnazione turno...',
                        icon: 'info',
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                } else {
                    return;
                }
            }
            
            let deletedWorkingHourIds = [];
            let deletedDWHNotifications = {};

            // Elimina tutti i turni esistenti per quella settimana se l'utente ha confermato
            if (shouldOverride) {
                for (const date of conflictingDates) {
                    const existingEntry = updatedEmployeeWorkingHours.find(entry => entry?.employeeId === selectedEmployee && entry?.date === date);
            
                    if (existingEntry) {
                        try {
                            // Filtra gli shifts che hanno dailyWorkingHourId o time_slot
                            const shiftsToDelete = existingEntry.shifts.filter(shift =>
                                shift.dailyWorkingHourId || Array.isArray(shift.time_slots) && shift.time_slots.length > 0
                            );
            
                            // Elimina ogni shift che ha un dailyWorkingHourId
                            for (const shift of shiftsToDelete) {
                                if (shift.dailyWorkingHourId) {
                                    await deleteEmployeeDailyWorkingHour(token, selectedEmployee, shift.dailyWorkingHourId);
                                    deletedWorkingHourIds.push({ employeeId: selectedEmployee, dailyWorkingHourId: shift.dailyWorkingHourId });
                                    
                                    // **Se il turno era confermato (status === true), aggiungilo in deletedDWHNotifications**
                                    if (shift.status === true) {
                                        deletedDWHNotifications = {
                                            ...deletedDWHNotifications,
                                            [shift.dailyWorkingHourId]: [
                                                selectedEmployee,
                                                moment(date).format('DD/MM/YYYY'),
                                                shift.ref_ou || '',
                                            ]
                                        };
                                    }
                                }

                                // Se il turno ha time_slots, eliminali
                                if (Array.isArray(shift.time_slots) && shift.time_slots.length > 0) {
                                    shift.time_slots = [];
                                }
                            }
            
                            // Aggiorna gli orari di lavoro dell'impiegato
                            updatedEmployeeWorkingHours = updatedEmployeeWorkingHours.map(wh => {
                                if (wh.employeeId === selectedEmployee && wh.date === date) {
                                    const updatedShifts = wh.shifts.filter(shift => !shiftsToDelete.includes(shift)); // Rimuovi i turni eliminati
                                    return { ...wh, shifts: updatedShifts };
                                }
                                return wh;
                            });
            
                            setEmployeeWorkingHours(updatedEmployeeWorkingHours);
                        } catch (error) {
                            console.error(`Errore nell'eliminazione del turno giornaliero per la data ${date}`, error);
                        }
                        
                    }
                }
            }

            // **Invio notifica specifica per i turni confermati eliminati**
            if (Object.keys(deletedDWHNotifications).length > 0) {
                try {
                    await postNotificationDWH(token, { deleted_ids: deletedDWHNotifications });

                } catch (notificationError) {
                    console.error('Errore durante l\'invio della notifica per turni confermati:', notificationError);
                    Swal.fire({
                        icon: "warning",
                        title: "Attenzione",
                        text: "Alcuni turni confermati sono stati eliminati, ma non è stato possibile inviare la notifica.",
                        confirmButtonText: "OK"
                    });
                }
            }
            // aggiornamento stato degli id DWH da confermare escludendo quelli elminati
            setUnconfirmedShiftsIds(prevUnconfirmedShiftsIds => 
                prevUnconfirmedShiftsIds.filter(shift => 
                    !deletedWorkingHourIds.some(deleted => 
                        deleted.employeeId === shift.employeeId && deleted.dailyWorkingHourId === shift.dailyWorkingHourId
                    )
                )
            );

            // Crea nuovi turni per ciascun giorno della settimana
            const newWorkingHours = [];
            const newWorkingHourIds = [];
            for (let i = 0; i < 7; i++) {
                // Crea una copia di startOfWeek e aggiungi il giorno i
                const date = moment(startOfWeek).add(i, 'days'); // Utilizza moment per aggiungere i giorni
                const formattedDate = date.format('YYYY-MM-DD'); // Formatta la data come stringa 'YYYY-MM-DD'
            
                const slot = selectedWeekWorkingHour.slots_by_weekday.find(slot => slot.week_day === i + 1);
            
                if (!slot) {
                    continue;
                }
    
                let timeSlotsData = [];
                let workingHourData = {
                    date: formattedDate,

                };

                if (slot.working_hour && slot.working_hour.time_slots) {
                    workingHourData.working_hour = slot.working_hour.id;
                    workingHourData.time_slots = [];
                    workingHourData.ou = selectedUnit?.id;
                    workingHourData.ou_name = selectedUnit?.name;
                } else if (slot.time_slots) {
                    timeSlotsData = slot.time_slots.map(timeSlot => ({
                        start_at: timeSlot.start_at,
                        end_at: timeSlot.end_at,
                        breaks: timeSlot.breaks.map(b => ({
                            start_at: b.start_at,
                            end_at: b.end_at
                        }))
                    }));

                    workingHourData.time_slots = timeSlotsData;
                    workingHourData.name = selectedWeekWorkingHour.name;
                    workingHourData.ou = selectedUnit?.id;
                    workingHourData.ou_name = selectedUnit?.name;
                }
                
    
                try {

                    const responseDWH = await createEmployeeWorkingHour(token, selectedEmployee, workingHourData);
    
                    const time_slots = responseDWH.working_hour ? convertWorkingHourToShifts(responseDWH.working_hour, workingHours) : responseDWH.time_slots;
                    updatedEmployeeWorkingHours = updatedEmployeeWorkingHours.map(entry => {
                        if (entry.employeeId === selectedEmployee && entry.date === formattedDate) {
                            const existingShifts = entry.shifts || [];
            
                            return {
                                ...entry,
                                shifts: [
                                    ...existingShifts,
                                    {
                                        dailyWorkingHourId: responseDWH.id,
                                        typology: 'turno',
                                        time_slots: time_slots,
                                        name: responseDWH?.name,
                                        ref_name: responseDWH?.ref_name,
                                        ref_ou: responseDWH?.ou,
                                    }
                                ],
                            };
                        }
                        return entry;
                    });
            
                    // Aggiungi il nuovo turno settimanale all'array dei nuovi turni
                    newWorkingHours.push({
                        employeeId: selectedEmployee,
                        date: formattedDate,
                        dailyWorkingHourId: responseDWH.id,
                        typology: 'turno',
                        time_slots: timeSlotsData,
                    });
                    newWorkingHourIds.push({
                        employeeId: selectedEmployee,
                        dailyWorkingHourId: responseDWH.id
                    });
                } catch (error) {
                    console.error('Errore nella creazione del turno giornaliero', error);
                    throw new Error('Errore nella creazione del turno giornaliero');
                }
            }
            
            setEmployeeWorkingHours(updatedEmployeeWorkingHours);

            // aggiungi l'id del nuovo turno e id dell'employee agli id dei turni da confermare            
            setUnconfirmedShiftsIds(prevUnconfirmedShiftsIds => {
                // Crea un array contenente solo i nuovi oggetti senza duplicati
                const newShifts = newWorkingHourIds.filter(newShift => {
                    // Controlla se il nuovo shift è già presente nell'array di prevUnconfirmedShiftsIds
                    return !prevUnconfirmedShiftsIds.some(
                        shift => shift.employeeId === newShift.employeeId && shift.dailyWorkingHourId === newShift.dailyWorkingHourId
                    );
                });
            
                // Aggiungi i nuovi shift all'array precedente
                return [...prevUnconfirmedShiftsIds, ...newShifts];
            });              

            setSelectedOption('');
            setSelectedWorkingHourId(null);
            setSelectedWeeklyWorkingHourId(null);
            setModalOpen(false);
            setIsLoading(false);

            Swal.close();
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Turno settimanale assegnato con successo!",
                showConfirmButton: false,
                timer: 1000
            });
        } catch (error) {
            console.error('Errore nella creazione del turno settimanale', error);
            Swal.close();
            Swal.fire('Errore...', error.message || 'Errore sconosciuto', 'error');
        }
    };
    

    const toggleNotificationSelection = (employeeId) => {
        setSelectedNotifications((prevSelected) =>
            prevSelected.includes(employeeId)
                ? prevSelected.filter((id) => id !== employeeId)
                : [...prevSelected, employeeId]
        );
    };
    
    const handleDeleteDailyWh = async (employeeId, dailyWhId, cf, formattedDay, employeeLN, employeeFN, shiftStatus, dwhRefOu) => {        
        if (profile.customer_type !== 'employee' || 
            profile.employee?.permissions.includes('hr.manage_shifts_all') || 
            profile.employee?.permissions.includes('hr.manage_shifts_ou')) {           
                
            const day = moment(formattedDay).format('DD/MM/YYYY');  
            setSelectedDay(day);

            const fullName = (employeeLN && employeeFN) 
                ? `${employeeLN} ${employeeFN}`.trim() 
                : cf;
            
            setSelectedEmployeeName(fullName);

            const currentEmployee = employeesWithActiveContract.find(employee => employee.id === employeeId);
            const employeeCalendarData = employeesCalendarData.find(data => data.id === employeeId);
            const typology = employeeCalendarData ? employeeCalendarData.typology : null;
        
            if (typology === 'fisso') {
                Swal.fire({
                    icon: 'info',
                    title: 'Turno Fisso',
                    text: 'Il dipendente selezionato ha il contratto con turno fisso e può essere eliminato nella sezione anagrafica',
                    showCancelButton: true,
                    confirmButtonText: 'Vai all\'anagrafica',
                    cancelButtonText: 'Annulla',
                    cancelButtonColor: '#d1d5db',
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = `/dipendenti/${cf}/edit?tab=4`;
                    }
                });
                return;
            }

            const confirmationMessage = shiftStatus 
            ? "Confermando, verrà eliminato il turno di lavoro selezionato e notificata l'azione al dipendente e gestori, se presenti."
            : "Questa azione eliminerà il turno di lavoro selezionato";

            Swal.fire({
                title: 'Confermi l\'eliminazione?',
                text: confirmationMessage,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: '#cbd5e1',
                cancelButtonText: 'Annulla',
                confirmButtonText: 'Sì, elimina!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        Swal.fire({
                            title: 'Eliminazione in corso...',
                            icon: 'info',
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            didOpen: () => {
                                Swal.showLoading();
                            }
                        });

                        const employeeWorkingHour = employeeWorkingHours.find(wh => wh.employeeId === employeeId);
                        let deletedWorkingHourIds = [];
                        const deletedDailyWh = employeeWorkingHour 
                            ? employeeWorkingHour.shifts.find(shift => shift.dailyWorkingHourId === dailyWhId) 
                            : null;
                        
                        await deleteEmployeeDailyWorkingHour(token, employeeId, dailyWhId);

                        const updatedEmployeeWorkingHours = employeeWorkingHours.map(wh => {
                            if (wh.employeeId === employeeId) {
                                const updatedShifts = wh.shifts.filter(shift => shift.dailyWorkingHourId !== dailyWhId); 
                        
                                return { ...wh, shifts: updatedShifts };
                            }
                            return wh;
                        });

                        setEmployeeWorkingHours(updatedEmployeeWorkingHours);
                        setUnconfirmedShiftsIds(prevUnconfirmedShifts =>
                            prevUnconfirmedShifts.filter(shift => !(shift.employeeId === employeeId && shift.dailyWorkingHourId === dailyWhId))
                        );

                        await updateTotalHours();
                    
                        Swal.close();
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Turno di lavoro eliminato con successo!",
                            showConfirmButton: false,
                            timer: 1000,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });


                    if (shiftStatus) {
                        try {
                            const data = [
                                dailyWhId || '',
                                employeeId || '',
                                moment(formattedDay).format('DD/MM/YYYY') || '',
                                dwhRefOu || '',
                            ];
                            
                            const formattedData = {
                                [data[0]]: [data[1], data[2], data[3]],
                            };

                            // await postNotificationDWH(token, data);
                            await postNotificationDWH(token, {
                                deleted_ids: formattedData
                            });

                        } catch (notificationError) {
                            console.error('Errore durante l\'invio della notifica:', notificationError);
                            Swal.fire({
                                icon: "warning",
                                title: "Attenzione",
                                text: "Il turno è stato eliminato, ma non è stato possibile inviare la notifica al dipendente.",
                                confirmButtonText: "OK"
                            });
                        }
                    }

                } catch (error) {
                    console.error('Errore durante l\'eliminazione del turno di lavoro:', error);
                    Swal.close();
                    Swal.fire('Errore...', 'Si è verificato un errore durante l\'eliminazione del turno di lavoro', 'error');
                }
                }
            });
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Non hai i permessi per eseguire questa azione',
                confirmButtonText: 'OK'
            });
        }
    };

    const handleEditOuPairing = (dipendente, dailyWh) => {
        setSelectedDWH({ employee: dipendente, dailyWh: dailyWh });
        setIsModalOuPairingOpen(true);
    };

    const closeModalPairingOuDWH = () => {
        setIsModalOuPairingOpen(false);
        setSelectedDWH(null);
    };


    const handleSelectOUtoPair = async (selectedUnit, dailyWhId, employeeId) => {
        const dwhName = selectedUnit ? `fascia oraria unità: ${selectedUnit?.name}` : 'Fascia oraria';

        try {
            const updatedData = await updateEmployeeDWHOuPair(token, employeeId, dailyWhId, selectedUnit ? selectedUnit.id : null);
            const updatedOuName = dwhName;
            const dateFromResponse = updatedData?.date || selectedDay;
            const indexToUpdate = employeeWorkingHours.findIndex(entry => entry.employeeId === employeeId && entry.date === dateFromResponse);
    
            if (indexToUpdate !== -1) {
                const updatedEmployeeWorkingHours = [...employeeWorkingHours];
    
                updatedEmployeeWorkingHours[indexToUpdate] = {
                    ...updatedEmployeeWorkingHours[indexToUpdate],
                    ref_name: updatedOuName,

                    shifts: updatedEmployeeWorkingHours[indexToUpdate].shifts.map(shift => ({
                        ...shift,
                        ref_name: updatedOuName,
                        ref_ou: selectedUnit ? selectedUnit.id : null,
                    })),
                };

                await updateTotalHours();
                setEmployeeWorkingHours(updatedEmployeeWorkingHours);
            }
    
        } catch (error) {
            console.error('Failed to update:', error);
        }
    };
    
    
    
    

    // non eliminare altrimenti non funziona assegnazione turno
    const handleSelectWorkingHour = (selected) => {    
        if (!selected) {
          return;
        }
        setSelectedWorkingHourId(selected.id);
    };

    useEffect(() => {
        setSelectedWorkingHourId(null);
        setSelectedWeeklyWorkingHourId(null);
      }, [selectedOption]);

    const handleToggleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
    };

    const handleCloseModal = () => {
        setSelectedOption('');
        setSelectedWorkingHourId(null);
        setSelectedWeeklyWorkingHourId(null);
        setModalOpen(false);
    };

    const calculateTotalHours = (shifts) => {
        let totalMinutes = 0;
        
        shifts.forEach((shift) => {
            if (Array.isArray(shift.time_slots)) {
                shift.time_slots.forEach((slot) => {
                    const durationInMinutes = slot.duration || 0;
        
                    if (typeof durationInMinutes === 'number' && durationInMinutes >= 0) {
                        totalMinutes += durationInMinutes;
                    } else {
                        console.error('Invalid duration found in time slot:', slot);
                    }
                });
            }
        });
    
        const totalHours = Math.floor(totalMinutes / 60);
        const remainingMinutes = totalMinutes % 60;
        
        if (totalHours > 0 && remainingMinutes > 0) {
            return `${totalHours} h, ${remainingMinutes} min`;
        } else if (totalHours > 0) {
            return `${totalHours} h`;
        } else if (remainingMinutes > 0) {
            return `${remainingMinutes} min`;
        } else {
            return ``;
        }
    };
    
    const calculateWeeklyTotalMinutes = (employeeWorkingHours) => {
        let weeklyTotalMinutes = 0;
    
        employeeWorkingHours.forEach((day) => {
            if (Array.isArray(day.shifts)) {
                const dailyTotalMinutes = day.shifts.reduce((totalMinutes, shift) => {
                    if (Array.isArray(shift.time_slots)) {
                        const shiftTotalMinutes = shift.time_slots.reduce((slotMinutes, slot) => {
                            const durationInMinutes = slot.duration || 0;
    
                            return slotMinutes + (typeof durationInMinutes === 'number' && durationInMinutes >= 0 ? durationInMinutes : 0);
                        }, 0);
    
                        return totalMinutes + shiftTotalMinutes;
                    }
                    return totalMinutes;
                }, 0);
                weeklyTotalMinutes += dailyTotalMinutes;
            }
        });
    
        return weeklyTotalMinutes;
    };
    
    const formatMinutesToHours = (totalMinutes) => {
        const totalHours = Math.floor(totalMinutes / 60);
        const remainingMinutes = Math.round(totalMinutes % 60);
        
        if (totalHours > 0 && remainingMinutes > 0) {
            return `${totalHours} H, ${remainingMinutes} MIN`;
        } else if (totalHours > 0) {
            return `${totalHours} H`;
        } else if (remainingMinutes > 0) {
            return `${remainingMinutes} MIN`;
        } else {
            return `0`;
        }
    };    

    const handleInfoEmloyeeFisso = (id, cf) => {
        Swal.fire({
            icon: 'info',
            title: 'Turno Fisso',
            text: 'Il dipendente ha un turno fisso. Eventuali modifiche del turno assegnato possono essere effettuate nell\'anagrafica',
            showCancelButton: true,
            confirmButtonText: 'Vai all\'anagrafica',
            cancelButtonText: 'Annulla',
            cancelButtonColor: '#d1d5db',
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = `/dipendenti/${cf}/edit?tab=4`;
            }
        });
    };

    const handleSelectUnit = (selected) => {
        const unit = selected === 'all' || !selected ? null : selected;
        setSelectedUnit(unit);
    };

    const handleResetUnitSelection = () => {
        setSelectedUnit(null);
    };

    const handleResetOUtoPairSelection = () => {
        setSelectedOuToPair(null);
    };

    const handleConfirmSingleShift = async (employee, dailyWorkingHourId) => {      
        // const nightShiftActive = isNightShiftActive;
        
        const employeeId = employee.id;
          
        try {
            Swal.fire({
                title: "Conferma in corso...",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await updateEmployeeWorkingHourStatus(token, employeeId, dailyWorkingHourId);

            await updateTotalHours();

            setEmployeeWorkingHours(prevWorkingHours =>
                prevWorkingHours.map(emp => ({
                    ...emp,
                    shifts: emp.shifts.map(shift =>
                        shift.dailyWorkingHourId === dailyWorkingHourId
                            ? { ...shift, status: true }
                            : shift
                    )
                }))
            );

            setUnconfirmedShiftsIds(prevUnconfirmedShifts =>
                prevUnconfirmedShifts.filter(shift =>
                    !(shift.employeeId === employeeId && shift.dailyWorkingHourId === dailyWorkingHourId)
                )
            );    
    
            Swal.fire({
                title: "Turno confermato!",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
            });
    
        } catch (error) {
            console.error("Errore nella conferma del turno:", error);
    
            Swal.fire({
                title: "Errore!",
                text: "Non è stato possibile confermare il turno.",
                icon: "error",
                confirmButtonText: "OK"
            });
        }

        try {
            await postNotificationDWH(token, {
                approved_ids: [dailyWorkingHourId]
            });
        } catch (notificationError) {
            console.error("Errore nell'invio della notifica:", notificationError);
            Swal.fire({
                icon: "warning",
                title: "Attenzione",
                text: "Il turno è stato confermato, ma non è stato possibile inviare la notifica al dipendente.",
                confirmButtonText: "OK"
            });
        }
    };
    
    // RIPRISTINARE DOPO AVER INSERITO LE NOTIFICHE!!
    // const handleConfirmShifts = () => {
    //     Swal.fire({
    //         title: "Stai confermando i turni",
    //         text: `Confermi la pubblicazione di ${unconfirmedShiftsIds.length} turni? L'azione verrà notificata ${unconfirmedShiftsIds.length > 1 ? 'ai dipendenti' : 'al dipendente'} e gestori, se presenti.`,
    //         icon: "warning",
    //         showCancelButton: true,
    //         cancelButtonColor: "#cbd5e1",
    //         confirmButtonText: "Conferma",
    //         cancelButtonText: "Annulla",
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             publishShifts(unconfirmedShiftsIds);
    //         }
    //     });
    // };


    const handleConfirmShifts = () => {
        Swal.fire({
            title: "Stai confermando i turni",
            text: `Confermi la pubblicazione di ${unconfirmedShiftsIds.length} turni?`,
            icon: "warning",
            showCancelButton: true,
            cancelButtonColor: "#cbd5e1",
            confirmButtonText: "Conferma",
            cancelButtonText: "Annulla",
        }).then((result) => {
            if (result.isConfirmed) {
                publishShifts(unconfirmedShiftsIds);
            }
        });
    };
    
    const publishShifts = async (unconfirmedShiftsIds) => {
        if (unconfirmedShiftsIds.length === 0) return;
        let approvedIds = [];
        let blockedShiftsCount = 0;

        const validShifts = unconfirmedShiftsIds.filter(shift => {
            const shiftDate = new Date(shift.shiftDays);
            const month = shiftDate.getMonth() + 1;
            const year = shiftDate.getFullYear();
    
            if (blockedMonths.some(blockedMonth => blockedMonth.month === month && blockedMonth.year === year)) {
                blockedShiftsCount++;
                return false;
            }
            return true;
        });

        if (validShifts.length === 0) {
            Swal.fire({
                title: "Nessun turno disponibile",
                text: "Tutti i turni selezionati appartengono a mesi bloccati. Non è possibile confermare i turni.",
                icon: "warning",
                confirmButtonText: "OK"
            });
            return;
        }
        
        Swal.fire({
            title: "Conferma in corso...",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
       
        try {
            await Promise.all(
                validShifts.map(async ({ employeeId, dailyWorkingHourId }) => {
                    await updateEmployeeWorkingHourStatus(token, employeeId, dailyWorkingHourId);
                    approvedIds.push(dailyWorkingHourId);
                })
            );
    
            const confirmedShiftIds = validShifts.map(shift => shift.dailyWorkingHourId);
    
            setEmployeeWorkingHours(prevWorkingHours =>
                prevWorkingHours.map(emp => ({
                    ...emp,
                    shifts: emp.shifts.map(shift =>
                        confirmedShiftIds.includes(shift.dailyWorkingHourId)
                            ? { ...shift, status: true }
                            : shift
                    )
                }))
            );
            
            if (blockedShiftsCount > 0) {
                Swal.fire({
                    title: "Turni parzialmente confermati",
                    text: `Non è stato possibile confermare tutti i turni in quanto alcuni fanno parte di un mese bloccato. Sono stati confermati ${validShifts.length} turni.`,
                    icon: "info",
                    confirmButtonText: "OK"
                });
            } else {
                Swal.fire({
                    title: "Turni confermati!",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            setUnconfirmedShiftsIds(prevUnconfirmedShifts =>
                prevUnconfirmedShifts.filter(({ dailyWorkingHourId }) =>
                    !confirmedShiftIds.includes(Number(dailyWorkingHourId))
                )
            );
        } catch (error) {
            console.error("Errore nella conferma dei turni:", error);
            Swal.close();
    
            Swal.fire({
                title: "Errore!",
                text: "Si è verificato un problema durante la conferma dei turni.",
                icon: "error",
                confirmButtonText: "OK"
            });
        }

        if (approvedIds.length > 0) {
            try {
                await postNotificationDWH(token, { approved_ids: approvedIds });
            } catch (error) {
                console.error("Errore nell'invio della notifica:", error);
                Swal.fire({
                    title: "Errore di notifica!",
                    text: "Si è verificato un problema durante l'invio della notifica.",
                    icon: "error",
                    confirmButtonText: "OK"
                });
            }
        }
    };

    // const handleEditDailyWh = (employeeId: number, selectedDay: string, dailyWorkingHourId: number) => {
    //     setSelectedDailyWh(dailyWorkingHourId);
    //     setSelectedDay(selectedDay);  
    //     setModalEditDailyWhOpen(true);
    //     setEmployeeEditDailyWh(employeeId); 
    // };

    // const handleEditDailyWhCloseModal = () => {
    //     setModalEditDailyWhOpen(false);
    //     setSelectedShift(null);
    //     setSelectedDay(null);
    // };



    // if(isLoading)
    //     return (
    //         <div className='w-full'>
    //             <Fetching />
    //         </div>
    //     );
    if (isError) return <div>Error loading data</div>;
  
    return (
        <>
        <div className="min-h-full">
            <PopoverComponentCustom title='Assegna Turni' />
            {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
                <div className="w-full">
                    <div className="bg-orange-100 text-orange-600 p-4 mb-6">
                        <p className="text-center text-sm font-semibold">
                            Il profilo non è completo. <br />
                            Compila i campi mancanti{' '}
                            <Link
                            to="/profilo/fatturazione"
                            className="text-indigo-600 hover:text-indigo-800 underline"
                            >
                            cliccando qui
                            </Link>
                        </p>
                    </div>
                </div>
            )}
            <main className="mt-10 pb-4 flex justify-center">
                <div className='container mx-4 px-3 rounded-md'>
                    <div className='grid md:grid-cols-5 grid-cols-1 md:mx-4 mx-6 pb-5 z-30'>
                        <div className='col-hidden lg:block lg:col-span-1'></div>
                        <div className='col-span-1 flex items-center justify-start lg:justify-end lg:me-5'>
                            <h1 className="block font-medium text-gray-700 mb-4 md:mb-0 uppercase text-sm">Unità Organizzativa</h1>
                        </div>
                        {isLoading ? (
                            'Caricamento...'
                        ) : (
                            <div className='col-span-1 flex items-center w-64'>
                                <ComboboxAutocomplete
                                    options={units}
                                    bgActiveColor="bg-indigo-50"
                                    textActiveColor="text-gray-900"
                                    placeholder='Seleziona Unità Organizzativa...'
                                    onChange={handleSelectUnit}
                                    value={selectedUnit}
                                    positionOptions='absolute'
                                    zIndex='z-40'
                                />
                        </div>
                        )}
                        <div className="col-span-1 flex items-center ml-10">
                            <button
                                className={`w-28 mt-2 sm:mt-0 inline-flex justify-center align-middle items-center rounded bg-indigo-600 h-6 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 ${!selectedUnit ? 'invisible' : ''}`}
                                onClick={handleResetUnitSelection}
                                disabled={!selectedUnit}
                            >
                                Reset selezione
                            </button>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-4 mb-8 justify-center items-center">
                        <div className='col-span-1 hidden md:block'>
                            <button 
                                className="flex items-center justify-center text-gray-700 font-semibold px-1 border border-solid shadow-md me-3 rounded-md hover:bg-gray-100" 
                                title="Back" 
                            >
                                <Link to={`/shift_management`} className='flex items-center'>
                                    <p className='p-2 text-sm'>Torna indietro</p>
                                
                                </Link>
                            </button>
                        </div>
                        <div className="col-span-1 md:col-span-2 items-center justify-center border border-solid rounded-md z-30">
                            <ComboboxMultiSelectAPI
                                getData={async (query) => {
                                    if (query.trim() === '') {
                                    return Promise.resolve([]);
                                    }

                                    const page = 1;
                                    const pageSize = 5;

                                    try {
                                    const res = await getEmployeesWithActiveContract(token, query, 'hr_active', null, page, pageSize);
                                    

                                    const employeesArray = Array.isArray(res.results) ? res.results : [];
                                    return employeesArray; 
                                    } catch (error) {
                                    console.error("Errore durante il recupero dei dati:", error);
                                    return [];
                                    }
                                }}
                                getDisplay={(dip) => dip.last_name && dip.first_name ? `${dip.last_name} ${dip.first_name}` : dip.cf}
                                getId={(dip) => dip.id}
                                selectedValues={selectedActiveContractEmployees}
                                onChange={handleSelectionActiveContractChange}
                                placeholder="Cerca dipendente..."
                            />
                        </div>
                        
                    </div>
                    {selectedActiveContractEmployees.length > 0 ? (
                        <div className="ml-4">
                            <div className="flex flex-wrap gap-2 mt-2">
                                {selectedActiveContractEmployees.map((employee) => (
                                    <div
                                        key={employee.id}
                                        className="inline-flex items-center px-3 py-1 rounded-full bg-indigo-200 text-indigo-800 text-xs font-medium cursor-pointer hover:bg-indigo-300"
                                        onClick={() => handleDeselectEmployee(employee.id)}
                                    >
                                        {employee?.last_name && employee?.first_name
                                            ? `${employee?.last_name} ${employee?.first_name}`
                                            : employee?.cf}
                                        <span className="ml-2 text-gray-600 hover:text-red-500">&times;</span>
                                    </div>
                                ))}
                                <button
                                    className="inline-flex items-center rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500"
                                    onClick={handleResetSelection}
                                >
                                    Reset selezione
                                </button>
                            </div>
                        </div>
                    ) : null}
                    <div className='px-3 py-3 w-full' style={{ position: 'relative', zIndex: '25'}}> 
                        <ListBoxPageSize value={pageSizeActiveContract} onChange={handlePageSizeActiveChange} />
                    </div>

                    <div className='grid grid-cols-1 w-full'>
                        <div
                            style={{ flex: '1 1 auto', width: 'auto' }}
                            className="py-5 px-4 border-t border-l border-r border-gray-200 text-center text-xs font-semibold text-gray-600 uppercase align-middle"
                        >
                            <div className='grid grid-cols-3 sm:grid-cols-1 md:grid-cols-5 sm:justify-start md:justify-around'>
                                <div className='col-span-1 p-2 flex align-center justify-end sm:justify-center md:justify-end me-3'>
                                    <button
                                        className='text-gray-700 font-semibold px-1 border border-solid shadow-md rounded-md hover:bg-gray-100'
                                        onClick={() => handleNavigateWeek(-1)}
                                    >
                                        <ChevronLeftIcon className='w-5 h-5' />
                                    </button>
                                </div>
                                <div className='col-span-1 p-2 flex align-center md:justify-end sm:justify-center me-3'>Seleziona Settimana</div>
                                <span className='col-span-1 p-2 align-center justify-start sm:justify-center md:justify-start sm:hidden flex'>
                                    <button
                                        className='text-gray-700 font-semibold px-1 border border-solid shadow-md rounded-md hover:bg-gray-100'
                                        onClick={() => handleNavigateWeek(1)}
                                    >
                                        <ChevronRightIcon className='w-5 h-5' />
                                    </button>
                                </span>
                                <div
                                    onClick={handleSelectClick}
                                    style={{ cursor: 'pointer' }}
                                    className='col-span-3 sm:col-span-2 border border-gray-300 rounded-md shadow-md p-2 pl-4 flex items-center md:w-4/5 justify-between'
                                >
                                    <div>
                                        {currentWeek.length > 0 && `${getWeekRange(currentWeek[0], currentWeek[currentWeek.length - 1])} / ${selectedMonth.getFullYear()}`}
                                    </div>
                                    {!calendarVisible ? <ChevronDownIcon className='h-4 w-4' /> : <ChevronUpIcon className='h-4 w-4' />}
                                </div>
                                <div className='col-span-1 p-2 align-center justify-start sm:justify-center md:justify-start hidden sm:flex'>
                                    <button
                                        className='text-gray-700 font-semibold px-1 border border-solid shadow-md rounded-md hover:bg-gray-100'
                                        onClick={() => handleNavigateWeek(1)}
                                    >
                                        <ChevronRightIcon className='w-5 h-5' />
                                    </button>
                                </div>
                            </div>
                            {calendarVisible &&
                                <CalendarWeekSelect
                                    onWeekSelect={handleWeekSelect}
                                    onCloseCalendar={handleSelectClick}
                                    selectedMonth={selectedMonth}
                                />
                            }
                        </div>
                    </div>

                    {unconfirmedShiftsIds.length > 0 && (
                        <div className="border-x border-gray-200 flex justify-end pb-3">
                            <button
                                onClick={handleConfirmShifts}
                                className="bg-orange-500 text-white py-1 px-2 rounded-md shadow-md hover:bg-orange-300 uppercase text-sm font-semibold me-3"
                            >
                                Conferma turni ({unconfirmedShiftsIds.length})
                            </button>
                        </div>
                    )}

                   {loadingEmployee ? (
                        <Fetching />
                   ) : (
                        <div className="overflow-x-auto" style={{ maxHeight: '50vh' }}>
                            <table className="min-w-full w-full divide-y divide-gray-200" style={{ overflowY: 'auto', tableLayout: 'auto' }}>
                                <thead className='bg-white' style={{ position: 'sticky', top: -1, zIndex: 20 }}>
                                    <tr className='border-x' style={{ position: 'sticky', bottom: 0, zIndex: '10', backgroundColor: 'white', width: '100%' }}>
                                        {loadingTotalHours ? (
                                            <td colSpan={9} className="pb-2 pl-3 text-left text-xs bg-white font-semibold text-gray-600 uppercase">
                                                Caricamento...
                                            </td>
                                        ) : (
                                            <>
                                                {!loadingTotalHours && isTotalHoursError ? (
                                                    <td colSpan={9} className="pb-2 pl-3 text-left text-xs bg-white font-semibold text-gray-600 uppercase">
                                                        <ExclamationTriangleIcon className='inline-block h-4 w-4 text-orange-500' /> Errore, non è possibile effettuare il calcolo delle ore
                                                    </td>
                                                ) : ( 
                                                    <td colSpan={9} className="pb-2 text-left text-xs bg-white font-semibold text-gray-600 uppercase">
                                                        <hr className="border-y border-gray-300 mb-2" />
                                                                {
                                                                    selectedUnit ? (
                                                                        <span className='ml-2'>Totale Ore Settimanali Assegnate e confermate Per <strong>{selectedUnit?.name}</strong>: {formatMinutesToHours(totalAssignedHours * 60)}</span>
                                                                    ) : (
                                                                        <span className='ml-2'>Selezionare un'unità Organizzativa per visualizzare il calcolo delle ore confermate</span>
                                                                    )
                                                                }
                                                        <hr className="border-gray-300 mt-2" /> 
                                                    </td>
                                                )}
                                            </>
                                        )}
                                    </tr>
                            
                                    <tr>
                                        <th className="min-w-[9rem] sticky left-0 pl-4 py-3 border-2 border-gray-200 text-left text-xs font-semibold text-gray-600 uppercase bg-white" style={{ zIndex: 20, width: '10%' }}>
                                            Dipendenti
                                        </th>
                                        {currentWeek.map((day, index) => {
                                            const formattedDay = formatDate(day);
                                            const isHoliday = holidays.some(holiday => holiday.date === formattedDay);
                                            const weekend = isWeekend(day);  

                                            return (
                                                <th
                                                    key={index}
                                                    className={`min-w-[9rem] py-3 px-4 border-2 border-gray-200 text-center text-xs uppercase ${isHoliday ? 'text-amber-600 font-bold' : 'text-gray-600 font-semibold'} ${weekend ? 'text-indigo-600 font-bold' : 'text-gray-600 font-semibold'}`}
                                                    style={{ width: '10%' }}
                                                >
                                                    <div>{formatDay(day)}</div>
                                                </th>
                                            );
                                        })}
                                        <th
                                            className="min-w-[9rem] text-xs font-semibold text-gray-600 uppercase bg-gray-50 border-2 border-gray-200"
                                            style={{
                                                position: 'sticky',
                                                right: 0,
                                                background: 'white',
                                                zIndex: 2,
                                                border: '2px solid #e5e7eb',
                                                width: '20%',
                                            }}
                                        >
                                            Ore settimanali
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {loadingEmployee && (
                                        <tr>
                                            <td colSpan={9} className="py-3 px-4 border-2 border-gray-200 text-center">
                                                <Fetching />
                                            </td>
                                        </tr>
                                    )}
                                    {selectedEmployees.length === 0 && (
                                            <tr>
                                                <td colSpan={9} className="min-w-[9rem] py-3 px-4 border-2 border-gray-200 text-center text-sm font-semibold text-gray-600 uppercase">
                                                    Non sono presenti anagrafiche
                                                </td>
                                            </tr>
                                        )
                                    }
                                    {selectedEmployees
                                        .filter(employee =>
                                            selectedActiveContractEmployees.length === 0 ||
                                            selectedActiveContractEmployees.some(selected => selected.id === employee.id)
                                        )
                                        .sort((a, b) => {
                                            const aValue = a.last_name || a.cf;
                                            const bValue = b.last_name || b.cf;
                                            return aValue.localeCompare(bValue);
                                        })
                                        .map((dipendente) => (
                                            <tr key={dipendente.id}>
                                                <td
                                                    className="sticky left-0 z-10 pl-2 py-3 pe-3 border-2 border-gray-200 text-left text-xs bg-white font-semibold text-gray-600 uppercase"
                                                    style={{ width: '10%', wordBreak: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word' }}
                                                    title={dipendente.first_name ? `${dipendente.last_name} ${dipendente.first_name}` : dipendente.cf}
                                                >
                                                    <Link to={`/dipendenti/${dipendente.cf}`} className="hover:text-indigo-600">
                                                        {dipendente.first_name ? `${dipendente.last_name} ${dipendente.first_name}`.slice(0, 25) : dipendente.cf}
                                                        {dipendente.first_name && `${dipendente.last_name} ${dipendente.first_name}`.length > 25 ? '...' : ''}
                                                    </Link>
                                                </td>
                                                {currentWeek.map((day, index) => {
                                                    const formattedDay = formatDate(day);
                                                    const workingHour = employeeWorkingHours.find(wh => wh.date === formattedDay && wh.employeeId === dipendente.id);
                                                    
                                                    const isHoliday = holidays.some(holiday => holiday.date === formattedDay);
                                                    const weekend = isWeekend(day); 
                                                    const hasActiveContract = workingHour?.has_active_contract === true;
                                                    const weekHours = workingHour?.week_hours;
                                                    const shiftType = workingHour?.shift_type;
                                                    const belongsAnotherOU = selectedUnit && workingHour?.shifts?.some(shift => shift.ref_ou && shift.ref_ou !== selectedUnit?.id);
                                                    const totalDuration = calculateTotalHours(workingHour?.shifts || []);
                                                    const isFisso = workingHour?.shift_type === 'fisso';
                                                    const canHaveShift = (weekHours && hasActiveContract) || (shiftType === 'a_chiamata' && hasActiveContract);
                                                    const dayBlocked = isDayBlocked(formattedDay);
                                                    
                                                    return (
                                                        <td
                                                            key={index}
                                                            className={`relative py-1 px-1 border-2 border-gray-200 whitespace-pre-line text-center text-xs ${
                                                                !hasActiveContract ? 'bg-gray-300 cursor-pointer' : 
                                                                workingHour && workingHour.typology === 'senza_calendario' ? 'bg-gray-100 cursor-pointer' : 'bg-white'
                                                            } align-top font-semibold text-gray-900 min-h-full`}
                                                            style={
                                                                !hasActiveContract
                                                                ? PatternInactiveEmployee()
                                                                : workingHour && workingHour.typology === 'senza_calendario'
                                                                ? { backgroundColor: '#f3f4f6', cursor: 'pointer' }
                                                                : { 
                                                                    width: '10%',
                                                                    ...(isHoliday && SvgHoliday()),
                                                                    ...(weekend && SvgPattern()),
                                                                }
                                                            }
                                                            onClick={() => {
                                                                if (dayBlocked) {
                                                                    Swal.fire({
                                                                        icon: 'error',
                                                                        title: 'Il giorno è bloccato',
                                                                        text: 'Modifiche non consentite.',
                                                                        showConfirmButton: true,
                                                                        confirmButtonText: 'OK',
                                                                    });
                                                                    return;
                                                                } 
                                                                
                                                                if (!hasActiveContract) {
                                                                    Swal.fire({
                                                                        title: 'Nessun contratto attivo',
                                                                        html: `Per modificare i dati del contratto o crearne uno nuovo, clicca <a href="/dipendenti/${dipendente.cf}/edit?tab=2" style="color: #6366F1;">QUI</a>`,
                                                                        icon: 'warning',
                                                                    });
                                                                } else if (workingHour && workingHour.typology === 'senza_calendario') {
                                                                    Swal.fire({
                                                                        title: 'Contratto Senza Calendario',
                                                                        text: 'La tipologia di contratto del dipendente è "senza calendario" e non è possibile assegnare un turno.',
                                                                        icon: 'warning',
                                                                    });
                                                                } else if (!workingHour) {
                                                                    handleSelectedDay(dipendente.id, formattedDay, dipendente.cf, dipendente.last_name || '', dipendente.first_name || '');
                                                                }
                                                            }}
                                                        >
                                                            { (
                                                                <>
                                                                    {workingHour ? (
                                                                        <div className='pb-8 mb-4'>
                                                                            <ShiftCard 
                                                                                workingHour={workingHour} 
                                                                                dipendente={dipendente}
                                                                                handleDeleteDailyWh={handleDeleteDailyWh}
                                                                                formattedDay={formattedDay}
                                                                                selectedUnit={selectedUnit?.id}
                                                                                handlePlusCircleClick={handlePlusCircleClick}
                                                                                handleEditOuPairing={handleEditOuPairing}
                                                                                handleConfirmSingleShift={handleConfirmSingleShift}
                                                                                dayBlocked={dayBlocked}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
                                                                            {canHaveShift ? (
                                                                                <PlusCircleIcon className="text-indigo-500 hover:bg-indigo-50 rounded-2xl hover:text-indigo-500 cursor-pointer w-10 h-10" onClick={() => handlePlusCircleClick(dipendente.id, formattedDay, dipendente.cf, dipendente.last_name || '', dipendente.first_name || '', selectedUnit || '')} />
                                                                            ) : (
                                                                                <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
                                                                                    <div className="flex flex-col items-center justify-center text-gray-500">
                                                                                        <NoSymbolIcon className="w-8 h-8 text-red-500 mb-2" />
                                                                                        <p>Orario lavorativo non presente</p>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                            {shiftType !== 'senza_calendario' && (
                                                                <div  className='absolute bottom-0 w-full'>
                                                                    {shiftType !== 'senza_calendario' && (
                                                                    <div className="text-xs font-semibold justify-center flex text-gray-900 my-0.5">
                                                                        {totalDuration ? totalDuration : ''}
                                                                    </div>
                                                                    )}
                                                                    {canHaveShift && totalDuration && (
                                                                        <div className="left-0 right-0 flex items-center justify-center border-t w-full py-1">
                                                                            <div className='flex justify-center'>
                                                                                {isFisso ? (
                                                                                    <div>
                                                                                        <InformationCircleIcon className="text-gray-900 font-semibold hover:text-indigo-600 rounded-2xl cursor-pointer w-5 h-5" 
                                                                                            onClick={() => handlePlusCircleClick(
                                                                                                dipendente.id, 
                                                                                                formattedDay, 
                                                                                                dipendente.cf, 
                                                                                                dipendente.last_name || '', 
                                                                                                dipendente.first_name || '', 
                                                                                                selectedUnit || ''
                                                                                            )} 
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div>
                                                                                        <CustomTooltip title="Aggiungi turno" placement="top-start">
                                                                                            <PlusCircleIcon 
                                                                                                className="text-gray-900 font-semibold hover:text-indigo-600 rounded-2xl cursor-pointer w-5 h-5"
                                                                                                onClick={() => {
                                                                                                    if (dayBlocked) {
                                                                                                        Swal.fire({
                                                                                                            icon: 'error',
                                                                                                            title: 'Il giorno è bloccato',
                                                                                                            text: 'Modifiche non consentite.',
                                                                                                            showConfirmButton: true,
                                                                                                            confirmButtonText: 'OK',
                                                                                                        });
                                                                                                        return;
                                                                                                    }
                                                                                                    handlePlusCircleClick(
                                                                                                        dipendente.id, 
                                                                                                        formattedDay, 
                                                                                                        dipendente.cf, 
                                                                                                        dipendente.last_name || '', 
                                                                                                        dipendente.first_name || '', 
                                                                                                        selectedUnit || ''
                                                                                                    );
                                                                                                }} 
                                                                                            />
                                                                                        </CustomTooltip>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </td>
                                                    );
                                                })}
                                                <td
                                                    style={{
                                                        position: 'sticky',
                                                        right: 0,
                                                        zIndex: 1,
                                                        width: '20%',
                                                        verticalAlign: 'top',
                                                    }}
                                                    className={`px-1 text-start text-xs font-semibold text-gray-600 border border-r border-2 border-gray-200 ${
                                                        dipendente?.active_contract?.shift_type === 'senza_calendario' ? 'bg-gray-100' : 'bg-white'
                                                    }`}
                                                >
                                                    {dipendente?.active_contract?.shift_type === 'senza_calendario' ? (
                                                        <div className='h-full w-full'></div>
                                                    ) : (
                                                        <div className='px-1 flex flex-col justify-center py-2' style={{ wordBreak: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word' }}>
                                                            <div className="flex pb-0.5 justify-center">
                                                                <span className="font-bold uppercase">Previste</span>
                                                            </div>
                                                            <div className="text-center rounded-md mb-2 bg-indigo-100">
                                                                {dipendente?.active_contract?.week_hours > 0 
                                                                    ? `${dipendente?.active_contract?.week_hours} H` 
                                                                    : '0'}
                                                            </div>
                                                            <div className="flex pb-0.5 justify-center">
                                                                <span className="font-bold uppercase">Assegnate</span>
                                                            </div>
                                                            <div className="text-center mb-2 bg-indigo-100 rounded-md">
                                                                {
                                                                    formatMinutesToHours(calculateWeeklyTotalMinutes(employeeWorkingHours.filter(wh => wh.employeeId === dipendente.id)))
                                                                }
                                                            </div>
                                                            {dipendente?.active_contract?.shift_type === 'a_chiamata' ? (
                                                                <div className="text-center bg-amber-100 text-gray-700 px-2 py-0.5 rounded-md">
                                                                    Contratto a chiamata
                                                                </div>
                                                                ) : (
                                                                !dipendente?.active_contract?.week_hours && (
                                                                    <div className="text-center bg-red-50 rounded-md">
                                                                        Non è presente l'orario lavorativo. <br /> 
                                                                        <span 
                                                                            className="text-indigo-700 underline cursor-pointer"
                                                                            onClick={() => window.location.href = `/dipendenti/${dipendente.cf}/edit?tab=2`}
                                                                        >
                                                                            SALVALO QUI
                                                                        </span>
                                                                    </div>
                                                                )
                                                            )}

                                                        
                                                            {
                                                                (() => {
                                                                    const assignedMinutes = calculateWeeklyTotalMinutes(employeeWorkingHours.filter(wh => wh.employeeId === dipendente.id));
                                                                    const plannedMinutes = dipendente?.active_contract?.week_hours * 60;
                                                                    const isAChiamata = dipendente?.active_contract?.shift_type === 'a_chiamata';

                                                                    const difference = assignedMinutes - plannedMinutes;
                                                                    if (!isAChiamata) {
                                                                        if (difference !== 0) {
                                                                            return (
                                                                                <>
                                                                                    <div className="flex pb-0.5 justify-center">
                                                                                        <span className="font-bold uppercase">Differenza</span>
                                                                                    </div>
                                                                                    <div className="text-center text-red-500" style={{bottom: 0}}>
                                                                                        {
                                                                                            difference > 0
                                                                                                ? `+${formatMinutesToHours(difference)}`
                                                                                                : `-${formatMinutesToHours(Math.abs(difference))}`
                                                                                        }
                                                                                    </div>
                                                                                </>
                                                                            );
                                                                        }
                                                                    }
                                                                    return null;
                                                                })()
                                                            }
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                   )}
                    {!hidePaginationActive && (
                        <div className="flex justify-between mt-8 px-8">
                            <button 
                                className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                onClick={handlePreviousPageActive}
                                disabled={pageActiveContract === 1}
                            >
                                Precedente
                            </button>
                            <span className='text-sm font-medium text-gray-900'>Pagina {pageActiveContract} di {Math.ceil(totalResultActiveContract / pageSizeActiveContract)}</span>
                            <button 
                                className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                onClick={handleNextPageActive} 
                                disabled={pageActiveContract * pageSizeActiveContract >= totalResultActiveContract}
                            >
                                Successivo
                            </button>
                        </div>
                    )}
                </div>
                
                {modalOpen && (
                    <Transition.Root show={modalOpen} as={Fragment}>
                        <Dialog className="relative" style={{ zIndex: '150'}} onClose={() => {}}>
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                                >
                                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                            </Transition.Child>

                            <div className="fixed inset-0 w-screen overflow-y-auto" style={{ zIndex: '300' }}>
                                <div className="flex min-h-full items-top justify-center p-4 text-center sm:items-center sm:p-0">
                                    <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    >
                                        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-gray-50 shadow-xl transition-all my-8 w-3/4 2xl:w-2/4 py-4 px-4">
                                            <div className="flex justify-end">
                                                <button
                                                type="button"
                                                className="border shadow text-gray-700 text-sm w-24 px-2 py-1 rounded-md hover:bg-gray-200 focus:outline-none font-semibold uppercase bg-white"
                                                onClick={handleCloseModal}
                                                >
                                                Chiudi
                                                </button>
                                            </div>
                                            {selectedDay && (
                                                <div className="w-full flex justify-center my-4">
                                                    <div className="w-full">
                                                        <Toggle
                                                            color="indigo"
                                                            gradeBgColor="600"
                                                            optionLeft="ASSEGNA TURNO GIORNALIERO"
                                                            optionMiddle="ASSEGNA TURNO SETTIMANALE"
                                                            optionRight="CREA FASCIA ORARIA"
                                                            selectedOption={selectedOption}
                                                            onChange={handleToggleChange}
                                                        />
                                                    </div>
                                                </div> 
                                            )}
                                            {selectedDay && selectedOption === "CREA FASCIA ORARIA" && (
                                                <>
                                                    <PairOrgUnit 
                                                        onSelectOrganizationalUnit={handleTemporarySelectUnit}           
                                                        selectedOU={selectedUnit}
                                                        onResetOrganizationalUnit={handleResetOUtoPairSelection}
                                                    />
                                                    <AddDailyWorkingHour 
                                                        selectedDay={selectedDay} 
                                                        onSaveDailyWorkingHour={handleSaveWorkingHour}
                                                    />
                                                </>
                                            )}

                                            {selectedDay && selectedOption === "ASSEGNA TURNO GIORNALIERO" && (
                                                <div className='grid grid-cols-1 px-8 mb-4 w-full bg-white py-4 border rounded-md shadow-md'>
                                                    {workingHours.length > 0 ? (
                                                        <div className='flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full'>
                                                            <div className='w-full sm:w-auto'>
                                                                <span className='text-sm font-medium text-gray-700'>Assegna Turno Giornaliero</span>
                                                            </div>
                                                            <div className='w-full border border-gray-200 rounded-lg'>
                                                                <ComboboxAutocomplete
                                                                    options={workingHours}
                                                                    bgActiveColor="bg-indigo-100"
                                                                    textActiveColor="text-gray-900"
                                                                    placeholder="Seleziona turno giornaliero..."
                                                                    onChange={(value) => setSelectedWorkingHourId(value?.id ?? null)}
                                                                    value={workingHours.find(wh => wh.id === selectedWorkingHourId) || null}
                                                                    positionOptions='relative'
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className='col-span-6 flex justify-center py-5 items-center w-full rounded-lg border-2 border-dashed border-gray-300 text-sm font-semibold text-gray-900'> 
                                                            <div className="text-center p-5">
                                                                <p>Nessun turno giornaliero presente</p>
                                                                <p>Vai alla pagina di <Link to="/shift_management?type=giornaliero"><span className='underline text-indigo-500 uppercase cursor-pointer'>creazione turno</span></Link></p>
                                                            </div>
                                                        </div>
                                                    )}
                                                    
                                                    <div className='col-span-6'>
                                                        {selectedWorkingHour && (
                                                            <TabellaTurnoGiornaliero selectedWorkingHour={selectedWorkingHour} />
                                                        )}
                                                        
                                                        {selectedWorkingHour && (
                                                            <div className='col-span-1 flex justify-center mt-4'>
                                                                <button
                                                                    className="py-2 bg-indigo-600 rounded-md mb-2 w-28 text-white hover:bg-indigo-500 font-semibold text-sm uppercase me-2"
                                                                    onClick={handleSaveWorkingHour}
                                                                >
                                                                    Salva
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            {selectedDay && selectedOption === "ASSEGNA TURNO SETTIMANALE" && (
                                                <div className='grid grid-cols-1 px-8 mb-4 w-full bg-white py-4 border rounded-md shadow-md'>
                                                    {weeklyWorkingHours.length > 0 ? (
                                                        <div className='flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full'>
                                                            <div className='w-full sm:w-auto'>
                                                                <span className='text-sm font-medium text-gray-700'>Assegna Turno Settimanale</span>
                                                            </div>
                                                            <div className='w-full border border-gray-200 rounded-lg'>
                                                                <ComboboxAutocomplete
                                                                    options={weeklyWorkingHours}
                                                                    bgActiveColor="bg-indigo-100"
                                                                    textActiveColor="text-gray-900"
                                                                    placeholder="Seleziona turno settimanale..."
                                                                    onChange={(value) => setSelectedWeeklyWorkingHourId(value?.id ?? null)}
                                                                    value={weeklyWorkingHours.find(wh => wh.id === selectedWeeklyWorkingHourId) || null}
                                                                    positionOptions='relative'
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className='col-span-6 flex justify-center py-5 items-center w-full rounded-lg border-2 border-dashed border-gray-300 text-sm font-semibold text-gray-900'> 
                                                            <div className="text-center p-5">
                                                                <p>Nessun turno settimanale presente</p>
                                                                <p>Vai alla pagina di <Link to="/shift_management?type=settimanale"><span className='underline text-indigo-500 uppercase cursor-pointer'>creazione turno</span></Link></p>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {wwhEmployeeDataDisplay && isWeekWorkingHours(wwhEmployeeDataDisplay) && wwhEmployeeDataDisplay.slots_by_weekday && wwhEmployeeDataDisplay.slots_by_weekday.length > 0 && (
                                                        <div className='col-span-6 mt-5'>
                                                            <div className="overflow-x-auto rounded-lg shadow-lg" style={{ maxWidth: '100%' }}>
                                                                <table className="w-full border-collapse overflow-auto pt-4">
                                                                    <thead>
                                                                        <tr>
                                                                            {daysOfWeek.map((day, index) => (
                                                                                <th key={index} className="px-4 py-2 bg-indigo-50 text-sm font-bold text-center whitespace-nowrap text-gray-500 border border-gray-300">
                                                                                    {day}
                                                                                </th>
                                                                            ))}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr className="px-1 py-2 text-sm text-center whitespace-nowrap text-gray-700">
                                                                            {daysOfWeek.map((day, columnIndex) => (
                                                                                <td key={columnIndex} className="p-1.5 mt-8 text-sm text-center whitespace-nowrap text-gray-700 align-top border border-gray-300">
                                                                                    {(wwhEmployeeDataDisplay.slots_by_weekday || []).flatMap((weekDay) => {
                                                                                        if (weekDay.week_day - 1 === columnIndex) {
                                                                                            const timeSlots = weekDay.working_hour?.time_slots || [];
                                                                                            const additionalTimeSlots = weekDay.time_slots || [];
                                                                                            const allTimeSlots = [...timeSlots, ...additionalTimeSlots];

                                                                                            allTimeSlots.sort((a, b) => {
                                                                                                const timeA = new Date(`1970-01-01T${a.start_at}`);
                                                                                                const timeB = new Date(`1970-01-01T${b.start_at}`);
                                                                                                return timeA.getTime() - timeB.getTime();
                                                                                            });

                                                                                            return allTimeSlots;
                                                                                        }
                                                                                        return [];
                                                                                    }).map((timeSlot, timeSlotIndex) => (
                                                                                        <div key={`${columnIndex}-${timeSlotIndex}`} className="mt-2 mb-5">
                                                                                            <BriefcaseIcon className='h-5 w-5 me-1.5 inline-block text-indigo-700' />
                                                                                            <span className="font-bold text-xs">
                                                                                                {timeSlot.start_at} - {timeSlot.end_at}
                                                                                            </span>
                                                                                            {timeSlot.breaks.map((breakItem, breakIndex) => (
                                                                                                <div key={breakIndex} className='flex justify-center items-center my-1 text-xs'>
                                                                                                    <LocalBarIcon style={{ height: '15px', width: '15px', color: '#4f46e5', marginRight: '4px' }} />
                                                                                                    <span>{`${breakItem.start_at} - ${breakItem.end_at}`}</span>
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    ))}
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
    
                                                    
                                                            {wwhEmployeeDataDisplay && (
                                                                <div className='text-gray-700 text-center text-sm font-semibold pt-3'>Totale ore settimanali: {formatHoursAndMinutes((wwhEmployeeDataDisplay.duration)/60)}</div>
                                                            )}
                                                            <div className='flex justify-center'>
                                                                <div className='col-span-1 flex justify-center mt-4'>
                                                                    <button
                                                                        className="py-2 bg-indigo-600 rounded-md w-28 text-white hover:bg-indigo-500 font-semibold text-sm uppercase me-2"
                                                                        onClick={handleSaveWeekWorkingHour}
                                                                    >
                                                                        Salva
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </Dialog.Panel>
                                    </Transition.Child>
                                </div>
                            </div>
                        </Dialog>
                    </Transition.Root>
                )}

                {isModalOuPairingOpen && (
                    <OuSelectionPairDWH 
                        dailyWh={selectedDWH} 
                        onClose={closeModalPairingOuDWH} 
                        onSelectOUtoPair={handleSelectOUtoPair}
                    />
                )}

                {/* {modalEditDailyWhOpen && (
                    <Transition.Root show={modalEditDailyWhOpen} as={Fragment}>
                    <Dialog className="relative z-10" onClose={handleEditDailyWhCloseModal}>
                        <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-gray-50 items-center flex justify-center mx-8 shadow-xl transition-all my-8 w-3/4 2xl:w-2/4 py-4">
                                <div className='px-4 w-full'>
                                {selectedDay && selectedDailyWh && (
                                    <EditDailyWorkingHour
                                    selectedDay={selectedDay}
                                    dailyWhId={selectedDailyWh}
                                    // shiftData={selectedDailyWh}
                                    employeeId={employeeEditDailyWh}
                                    onShiftUpdated={(shiftData, index) => {
                                        // update the shift data logic here
                                    }}
                                    
                                    />
                                )}
                                   
                                <div className="mt-2 pt-2 justify-center">
                                    <button
                                    type="button"   
                                    className="py-2 bg-gray-200 rounded-md mb-2 w-28 text-gray-700"
                                    onClick={handleEditDailyWhCloseModal}
                                    >
                                    Chiudi
                                    </button>
                                </div>
                                </div>
                            </Dialog.Panel>
                            </Transition.Child>
                        </div>
                        </div>
                    </Dialog>
                    </Transition.Root>
                )} */}

            </main>
        </div>
        
        {profile.customer_type !== 'employee' && (
            <div className='flex justify-center mt-4'>
                {showButton ? (
                    <div className='flex items-center justify-center text-gray-700 font-semibold px-1 border border-solid shadow-md me-3 rounded-md hover:bg-gray-100 w-1/3 mb-4' onClick={() => { setShowInactiveEmployee(true); setShowButton(false); }}> <span className='text-xs text-center uppercase py-2'>Mostra dipendenti non attivi</span></div>
                ) : (
                    <div className='flex items-center justify-center text-gray-700 font-semibold px-1 border border-solid shadow-md me-3 rounded-md hover:bg-gray-100 w-1/3' onClick={() => { setShowInactiveEmployee(false); setShowButton(true); }}><span className='text-xs uppercase py-2 text-center'> Nascondi dipendenti non attivi</span></div>
                )}
            </div>
        )}
       
        {showInactiveEmployee && (
            <InactiveEmployeesTable />
        )}


        <Footer />
        </>
    );
};
export default TableAssignWh;


const SvgBreak = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg" 
            version="1.1" 
            id="Layer_1" 
            x="0px"
            y="0px" 
            viewBox="0 0 117 122.88" 
            style={{ width: '14px', margin: '4px' }}
        >
        <g>
          <path d="M94.8,15.36c-1.18-0.34-1.86-1.56-1.53-2.74c0.34-1.18,1.56-1.86,2.74-1.53c3.15,0.9,5.79,2.39,7.82,4.59 c2.03,2.22,3.39,5.1,3.94,8.79c0.18,1.21-0.66,2.34-1.88,2.52c-1.21,0.18-2.34-0.66-2.52-1.88c-0.41-2.76-1.38-4.87-2.81-6.43 C99.13,17.12,97.17,16.04,94.8,15.36L94.8,15.36z M37.87,67.17L0.61,28.09c-0.84-0.89-0.81-2.29,0.08-3.13 c0.43-0.41,0.98-0.61,1.53-0.61v-0.01h14.53L2.27,9.86c-0.87-0.87-0.87-2.27,0-3.14c0.87-0.87,2.27-0.87,3.14,0l17.62,17.62h42.2 c0.46-6.48,3.24-12.31,7.52-16.64C77.44,2.94,83.92,0,91.08,0c7.16,0,13.64,2.94,18.34,7.7C114.1,12.45,117,19,117,26.23 c0,7.23-2.9,13.78-7.58,18.53c-4.7,4.76-11.18,7.7-18.34,7.7c-3.19,0-6.25-0.59-9.09-1.66c-2.33-0.88-4.51-2.1-6.48-3.6L56,67.18 v38.38l14.94,13.45c0.91,0.82,0.98,2.22,0.16,3.13c-0.44,0.49-1.04,0.73-1.65,0.73v0H24.77c-1.23,0-2.22-0.99-2.22-2.22 c0-0.7,0.32-1.32,0.82-1.73l14.5-13.36V67.17L37.87,67.17z M69.68,24.34h22.88c1.23,0,2.22,0.99,2.22,2.22 c0,0.66-0.29,1.26-0.75,1.67L78.64,44c1.5,1.08,3.15,1.98,4.92,2.65c2.33,0.88,4.87,1.37,7.52,1.37c5.93,0,11.3-2.43,15.18-6.36 c3.89-3.94,6.3-9.39,6.3-15.42c0-6.03-2.41-11.48-6.3-15.42c-3.88-3.93-9.25-6.36-15.18-6.36c-5.93,0-11.3,2.43-15.18,6.36 C72.42,14.33,70.13,19.06,69.68,24.34L69.68,24.34z M7.4,28.78l6.82,7.15c0.14-0.03,0.29-0.05,0.45-0.05h64.77 c0.28,0,0.54,0.05,0.79,0.14l7.08-7.25H7.4L7.4,28.78z M18.41,40.33l23.18,24.31c0.45,0.41,0.73,0.99,0.73,1.65v40.26h0 c0,0.6-0.24,1.2-0.72,1.63l-11.14,10.26h33.22l-11.29-10.16c-0.5-0.41-0.83-1.03-0.83-1.73V66.28h0.01c0-0.56,0.21-1.11,0.63-1.55 l23.83-24.41H18.41L18.41,40.33z"/>
        </g>
      </svg>
    );
};


const PatternInactiveEmployee = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23c7d2fe' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};


const SvgHoliday = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='48' height='32' viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23fde68a' fill-opacity='0.4'%3E%3Cpath d='M27 32c0-3.314 2.686-6 6-6 5.523 0 10-4.477 10-10S38.523 6 33 6c-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 6.627 0 12 5.373 12 12s-5.373 12-12 12c-2.21 0-4 1.79-4 4h-2zm-6 0c0-3.314-2.686-6-6-6-5.523 0-10-4.477-10-10S9.477 6 15 6c3.314 0 6-2.686 6-6h-2c0 2.21-1.79 4-4 4C8.373 4 3 9.373 3 16s5.373 12 12 12c2.21 0 4 1.79 4 4h2z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};

const SvgPattern = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='48' height='32' viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23e0e7ff' fill-opacity='0.4'%3E%3Cpath d='M27 32c0-3.314 2.686-6 6-6 5.523 0 10-4.477 10-10S38.523 6 33 6c-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 6.627 0 12 5.373 12 12s-5.373 12-12 12c-2.21 0-4 1.79-4 4h-2zm-6 0c0-3.314-2.686-6-6-6-5.523 0-10-4.477-10-10S9.477 6 15 6c3.314 0 6-2.686 6-6h-2c0 2.21-1.79 4-4 4C8.373 4 3 9.373 3 16s5.373 12 12 12c2.21 0 4 1.79 4 4h2z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};
